export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/about": [4],
		"/calculator": [5],
		"/contact": [6],
		"/guides": [7,[2]],
		"/guides/100k-income": [8,[2]],
		"/guides/1st-and-2nd-of-month": [9,[2]],
		"/guides/25k-income": [10,[2]],
		"/guides/40k-income": [11,[2]],
		"/guides/60k-income": [12,[2]],
		"/guides/80k-income": [13,[2]],
		"/guides/agency-changes": [14,[2]],
		"/guides/aime": [15,[2]],
		"/guides/covid-awi-drop": [16,[2]],
		"/guides/delayed-january-bump": [17,[2]],
		"/guides/delayed-retirement-credits": [18,[2]],
		"/guides/divorced-spouse": [19,[2]],
		"/guides/earnings-cap": [20,[2]],
		"/guides/earnings-record-paste": [21,[2]],
		"/guides/earnings-test": [22,[2]],
		"/guides/federal-taxes": [23,[2]],
		"/guides/filing-date-chart": [24,[2]],
		"/guides/government-shutdown": [25,[2]],
		"/guides/indexing-factors": [26,[2]],
		"/guides/inflation": [27,[2]],
		"/guides/integrations": [28,[2]],
		"/guides/international-agreements": [29,[2]],
		"/guides/maximum": [30,[2]],
		"/guides/mortality": [31,[2]],
		"/guides/nra": [32,[2]],
		"/guides/pia": [33,[2]],
		"/guides/privacy": [34,[2]],
		"/guides/projectionlab-review": [35,[2]],
		"/guides/senior-tax-deduction": [36,[2]],
		"/guides/spousal-benefit-filing-date": [37,[2]],
		"/guides/state-taxes": [38,[2]],
		"/guides/survivor-benefits": [39,[2]],
		"/guides/url-parameters": [40,[2]],
		"/guides/wep": [41,[2]],
		"/guides/will-social-security-run-out": [42,[2]],
		"/guides/work-credits": [43,[2]],
		"/strategy": [44]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';